'use client';
import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
  border-width: 0px;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
`;

export const CardContainer = styled.div`
  display: flex;
  gap: ${({ theme, $cardGap }) => theme.spacing($cardGap)};
  flex-direction: ${({ direction }) => direction};
  align-items: center;
`;

export const CardWrapper = styled.div`
  position: relative;
`;

export const PillContainer = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(0%, -35%);
  z-index: 1;
`;
